module.exports = __webpack_public_path__ + "static/hand_sanitizer-4777581bb82e45d45766e846edb4f618.png";